import { useState, useEffect } from 'react';
import { companyApiService } from '../services/companyApi';

export const useIrisAvatar = () => {
  const [avatarUrl, setAvatarUrl] = useState<string>('/irisavatar.jpg'); // Fallback par défaut
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadAvatar = async () => {
      try {
        // Utiliser l'API publique pour éviter les erreurs 401
        const profile = await companyApiService.getCompanyProfilePublic();
        
        // Utiliser l'avatar uploadé s'il existe, sinon fallback
        if (profile.iris_avatar_url) {
          setAvatarUrl(profile.iris_avatar_url);
        } else if (profile.iris_avatar) {
          setAvatarUrl(profile.iris_avatar);
        }
        // Sinon garder le fallback par défaut
        
      } catch (error: any) {
        // Ignorer silencieusement les erreurs et utiliser le fallback
        console.log('Impossible de charger l\'avatar IRIS, utilisation du fallback');
        // Garder le fallback par défaut en cas d'erreur
      } finally {
        setLoading(false);
      }
    };

    loadAvatar();
  }, []);

  return { avatarUrl, loading };
};
